import { render, staticRenderFns } from "./SurveyFormText.vue?vue&type=template&id=5f4e9366&scoped=true&"
import script from "./SurveyFormText.vue?vue&type=script&lang=js&"
export * from "./SurveyFormText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4e9366",
  null
  
)

export default component.exports